import type {DashboardProgressBucket} from './types';

export const ROADMAP_STATUS_COLORS: Record<DashboardProgressBucket, string> = {
  total: 'var(--dig-color__text__base)',
  completed: '#5BA250',
  onTrack: 'var(--dig-color__primary__base)',
  atRiskDelayed: '#C0154C',
  notStarted: '#6A645F',
  cancelled: '#6A645F',
};

export const normalizeRoadmapStatus = (status: string | null | undefined) => {
  const normalized = status?.replace(/\s+/g, ' ').trim();
  return normalized || null;
};

export const getRoadmapProgressBucket = (
  status: string | null | undefined
): DashboardProgressBucket | null => {
  switch (normalizeRoadmapStatus(status)?.toLocaleLowerCase()) {
    case 'done':
    case 'completed':
      return 'completed';
    case 'in progress':
    case 'on track':
      return 'onTrack';
    case 'blocked':
    case 'at risk':
    case 'delayed':
    case 'on hold':
      return 'atRiskDelayed';
    case 'cancelled':
      return 'cancelled';
    case 'backlog':
    case 'to do':
      return 'notStarted';
    default:
      return null;
  }
};

export const getRoadmapStatusPresentation = (status: string | null | undefined) => {
  switch (normalizeRoadmapStatus(status)?.toLocaleLowerCase()) {
    case 'done':
    case 'completed':
      return {asStatus: 'complete', color: ROADMAP_STATUS_COLORS.completed};
    case 'in progress':
    case 'on track':
      return {asStatus: 'on_track', color: ROADMAP_STATUS_COLORS.onTrack};
    case 'blocked':
    case 'at risk':
    case 'delayed':
    case 'on hold':
      return {asStatus: 'at_risk', color: ROADMAP_STATUS_COLORS.atRiskDelayed};
    case 'cancelled':
      return {asStatus: 'cancelled', color: ROADMAP_STATUS_COLORS.cancelled};
    case 'backlog':
    case 'to do':
      return {asStatus: 'not_started', color: ROADMAP_STATUS_COLORS.notStarted};
    default:
      return {asStatus: 'no_status', color: ROADMAP_STATUS_COLORS.notStarted};
  }
};
